/**
 * Challenge Actions Helpers
 * Pure functions for challenge action logic
 */

import type { UserPredictions } from '../types/challengeCard.types';

/**
 * Transform user predictions to API format
 */
export const transformPredictionsToApiFormat = (
  challengeId: string,
  userId: string,
  userPredictions: UserPredictions
): Array<{
  challengeId: string;
  matchId: string;
  userId: string;
  prediction: 'home' | 'draw' | 'away';
  homeScore: number;
  awayScore: number;
  outcome: 'home' | 'draw' | 'away';
}> => {
  return Object.entries(userPredictions)
    .filter(([_, prediction]) => prediction !== null)
    .map(([betId, prediction]) => ({
      challengeId,
      matchId: betId,
      userId,
      prediction: prediction!,
      homeScore: prediction === 'home' ? 1 : 0,
      awayScore: prediction === 'away' ? 1 : 0,
      outcome: prediction!,
    }));
};

/**
 * Check if user has any predictions
 */
export const hasPredictions = (userPredictions: UserPredictions): boolean => {
  return Object.values(userPredictions).some((prediction) => prediction !== null);
};

/**
 * Get prediction count
 */
export const getPredictionCount = (userPredictions: UserPredictions): number => {
  return Object.values(userPredictions).filter((prediction) => prediction !== null).length;
};

/**
 * Build success message for predictions update
 */
export const buildPredictionsSuccessMessage = (predictionCount: number, isPendingParticipant: boolean): string => {
  if (isPendingParticipant) {
    return `Challenge accepted and ${predictionCount} prediction${predictionCount !== 1 ? 's' : ''} saved!`;
  }
  return `Successfully updated ${predictionCount} prediction${predictionCount !== 1 ? 's' : ''}!`;
};
